export default __webpack_public_path__ + "static/media/male-before.d711358d.webp";